import React, { useState, useEffect } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const AddDivision = ({ onClose, onAddDivision }) => {
  const [loanName, setLoanName] = useState("");
  const [intrestRateId, setintrestRateId] = useState("");
  const [states, setStates] = useState([]);
  const [errors, setErrors] = useState({});
  const Api = process.env.REACT_APP_API;

  const validateForm = () => {
    const newErrors = {};
    if (!loanName) {
      newErrors.loanName = "Division name is required";
    }

    if (!intrestRateId) {
      newErrors.intrestRateId = "Please select Circle Id";
    }
    return newErrors;
  };

  useEffect(() => {
    const fetchStates = async () => {
      try {
        const response = await fetch(`${Api}/api/intrest-rates`);
        const data = await response.json();
        setStates(data.intrestRates);
      } catch (error) {
        console.error("Error fetching Circles:", error);
      }
    };

    fetchStates();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formErrors = validateForm();
    if (Object.keys(formErrors).length > 0) {
      setErrors(formErrors);
      toast.error("Please fill all Details");
      return;
    }

    const formData = {
      loanName,
      intrestRateId,
    };

    try {
      const response = await fetch(`${Api}/api/loan-types`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        const result = await response.json();
        console.log("Success:", result);
        toast.success("Added Successfully");
        onAddDivision(result);
        onClose(); // Close the popup after successful form submission
      } else {
        console.error("Error submitting form:", response.statusText);
        toast.error("Error submitting form");
      }
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };
  return (
    <div>
      <div className="page-header">
        <h3 className="page-title">Add Loan Type </h3>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <a href="!#" onClick={(event) => event.preventDefault()}>
                VFC
              </a>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              Add Loan Type
            </li>
          </ol>
        </nav>
      </div>

      <Modal show onHide={onClose}>
        <Modal.Header>
          <Modal.Title>Add Loan Type</Modal.Title>
          <Button
            variant="outline-danger"
            onClick={onClose}
            style={{ marginLeft: "auto" }}
          >
            X
          </Button>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit}>
            <Form.Group controlId="formLoanName">
              <Form.Label>Loan Name</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter Loan name"
                value={loanName}
                onChange={(e) => setLoanName(e.target.value)}
                isInvalid={!!errors.loanName}
              />
              <Form.Control.Feedback type="invalid">
                {errors.loanName}
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group controlId="formIntrestType">
              <Form.Label>Intrest Type</Form.Label>
              <Form.Control
                as="select"
                value={intrestRateId}
                onChange={(e) => setintrestRateId(e.target.value)}
                isInvalid={!!errors.divisionCode}
              >
                <option value="">Select Circle</option>
                {states.map((state) => (
                  <option key={state._id} value={state._id}>
                    {state.intrestName}
                  </option>
                ))}
              </Form.Control>
              <Form.Control.Feedback type="invalid">
                {errors.circleCode}
              </Form.Control.Feedback>
            </Form.Group>
          </Form>
          <button
            type="submit"
            className="btn btn-outline-primary btn-icon-text mt-3"
          >
            <i className="mdi mdi-file-check btn-icon-prepend"></i>
            Submit
          </button>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default AddDivision;
